import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Toast } from "primereact/toast";
import RegisterUserService from "../../services/RegisterUserService";
import $ from "jquery";
import "datatables.net";
import { MdAddCircleOutline } from "react-icons/md";
import AuthService from "../../services/AuthService";

function RegisterUser() {
  const [User, setUser] = useState([]);
  const toast = useRef(null);
  const tableRef = useRef(null);
  const clientId = AuthService.getLoggedInClientId();

  const navigate = useNavigate();

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const users = await RegisterUserService.getUsersByClientId(clientId);
        setUser(users);
      } catch (error) {
        console.error("Error fetching Users: ", error);
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Failed to fetch users data",
        });
      }
    };
    fetchUsers();
    setTimeout(() => {
      $("#tableData").DataTable();
    }, 1000);
  }, [clientId]);

  const Roles = [
    { id: 1, name: "SuperAdmin" },
    { id: 2, name: "Admin" },
    { id: 3, name: "Manager" },
    { id: 4, name: "Employee" },
  ];

  function renderUsers() {
    return User.filter((user) => {
      const roles = Roles.find((role) => role.id == user.roleId);
      return roles && roles.name !== "SuperAdmin";
    }).map((user) => {
      const roles = Roles.find((role) => role.id == user.roleId);
      const roleName = roles ? roles.name : "Unknown";

      return (
        <tr key={user.id}>
          <td class="align-middle text-center">
            <span class="text-secondary text-xs font-weight-bold">
              {user.firstName} {user.lastName}
            </span>
          </td>
          <td class="align-middle text-center">
            <span class="text-secondary text-xs font-weight-bold">
              {" "}
              {user.email}
            </span>
          </td>
          <td class="align-middle text-center">
            <span class="text-secondary text-xs font-weight-bold">
              {user.contactNumber}
            </span>
          </td>
          <td class="align-middle text-center">
            <span class="text-secondary text-xs font-weight-bold">{`${user.streetAddress}, ${user.city}, ${user.state}, ${user.country}, ${user.postalCode}`}</span>
          </td>
          <td class="align-middle text-center">
            <span class="text-secondary text-xs font-weight-bold">
              {roleName}
            </span>
          </td>
          <td class="align-middle text-center">
            <span class="text-secondary text-xs font-weight-bold">
              {user.isActive ? "Active" : "Inactive"}
            </span>
          </td>
          <td class="align-middle text-center">
            <span class="text-secondary text-xs font-weight-bold">
              <button
                className="btn btn-outline-dark btn-sm"
                onClick={() => navigate(`/edituser/${user.id}`)}
              >
                <i className="pi pi-pencil" style={{ fontSize: "1.5rem" }}></i>
              </button>
              <button
                className="btn btn-outline-light btn-sm"
                onClick={() => deleteUser(user.id)}
              >
                <i
                  className="pi pi-trash"
                  style={{ fontSize: "1.5rem", color: "red" }}
                ></i>
              </button>
            </span>
          </td>
        </tr>
      );
    });
  }

  const deleteUser = async (userId) => {
    try {
      await RegisterUserService.deleteUser(userId);
      toast.current.show({
        severity: "success",
        summary: "Success",
        detail: "User deleted successfully",
        life: 3000,
      });
      setUser(User.filter((user) => user.id !== userId));
    } catch (e) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to delete user",
        life: 3000,
      });
      console.log(e);
    }
  };

  return (
    <div>
      <Toast ref={toast} />
      <div className="form-group row">
        <div className="col-lg-12 float-end">
          <div className="col-lg-3 float-end">
            <a
              class="btn bg-gradient-dark mb-0 float-end"
              href="javascript:;"
              onClick={() => {
                navigate("/adduser");
              }}
            >
              <MdAddCircleOutline /> Add Employee
            </a>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="card my-4">
          <div class="card-body px-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0" id="tableData">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Name
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Email
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Contact Number
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Address
                    </th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                      Role
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Status
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>{renderUsers()}</tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegisterUser;
